import AbstractElement from "../../pages/AbstractElement";

class TabNav extends AbstractElement {

    private activeId: number;
    private navLinks: JQuery[];

    init(): void {
        super.init();
        this.initLinks();
    }

    private initLinks(): void {
        this.activeId = 0;
        this.navLinks = [];
        const links = this.template.find('.tab__nav__link').toArray();
        links.map((element: any, index: number) => {
            this.navLinks.push($(element));
            $(element).on('click tap', {id: index}, e => {
                e.preventDefault();
                this.emitter.emit('TAB_NAV_CLICK', {
                    id: e.data.id,
                    target: $(e.target).attr('href'),
                    bgColor: $(element).data('bg-color')
                });
                this.activeLink(e.data.id);
                this.scrollNav(e.data.id);
            });
        });
    }

    public scrollNav(id: number): void {
        if (id === null) return;
        let btnOffsetX: number = this.navLinks[id].offset().left;
        let targetX: number = this.template.scrollLeft() + btnOffsetX - 20;
        this.template.animate({
            scrollLeft: targetX
        }, 700);
    }

    public activeLink(id: number): void {
        this.activeId = id;
        this.template.find('.tab__nav__link').removeClass('active');
        this.template.find('.tab__nav__link:eq(' + id + ")").addClass('active');
    }
}

export default TabNav;